import { connect } from "react-redux";
import { Employee } from "@skbkontur/staff-common";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { reject } from "../../../../../Common/TypingUtils";
import { cancelImportEmployees, importEmployees } from "../State/ImportEmployeesActionCreators";

import { ImportEmployeesSidePage } from "./ImportEmployeesSidePage";

const mapStateToProps = (state: FullFormState) => ({
    active: state.importEmployees?.showSideBar ?? false,
    options: state.importEmployees?.options,
    initialState: state.importEmployees?.initialState,
    staffServiceUrl: state.settings.staffServiceUrl ?? reject("staffServiceUrl must be defined"),
    staffWidgetUrl: state.settings.staffWidgetUrl ?? reject("staffWidgetUrl must be defined"),
    employerId: state.settings.employerId,
    gfv: state.settings.gfv,
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onClose: () => dispatch(cancelImportEmployees()),
    onSubmit: (employees: Employee[]) => dispatch(importEmployees(employees)),
});

export const ImportEmployeesContainer = connect(mapStateToProps, mapDispatchToProps)(ImportEmployeesSidePage);
